// extracted by mini-css-extract-plugin
export default {"empty":"empty-Lguk","screenshot":"screenshot-ezZT"};